/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { ToggleMemoryGridRequest } from '../models/toggle-memory-grid.request';
import { FixMemoryGridRequest } from '../models/fix-memory-grid.request';
import { FlipMemoryGridRequest } from '../models/flip-memory-grid.request';
import { MemoryGrid } from '../models/memory-grid.entity';

export type MemoryGridUpdatePathVariables = {
	gameId: string;
	memoryGridId: string;
};

@Injectable()
export class MemoryGridService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public update(
		path: MemoryGridUpdatePathVariables,
		body:
			| ToggleMemoryGridRequest
			| FixMemoryGridRequest
			| FlipMemoryGridRequest,
	): Observable<MemoryGrid> {
		return this.http.patch<MemoryGrid>(
			`${this.config.apiUrl}/api/v3/private/games/${path.gameId}/phases/memory/${path.memoryGridId}`,
			body,
		);
	}
}
